/**
 * 인앱 장바구니 탭 배지 — 장바구니 수량이 바뀌면 앱에 통지한다(규약 3.1 setTabBadge).
 *
 * 설계: docs/superpowers/specs/2026-08-12-in-app-cart-badge-design.md
 *
 * 불변 규칙: 로컬에 들고 있는 수량에 더하지 않는다. 보고할 때마다 서버 총량을 읽는다.
 *
 *   앱의 탭은 각각 독립된 웹뷰라 다른 탭의 장바구니 변경을 알 수 없다. A탭이 3을 들고 있는 사이
 *   B탭에서 담아 4가 되면, A탭에서 담을 때 3+1=4를 보고해 배지가 틀어진다. 로컬 값을 쓰지 않으면
 *   이 문제 자체가 생기지 않는다 — 카트 쿠키는 웹뷰 간 공유되므로 어느 탭에서 /cart.js를 불러도
 *   같은 카트가 온다(규약 3.4).
 *
 *   같은 이유로 cart:update 의 detail.data.itemCount 는 읽지 않는다. 발신처마다 델타(product-form)와
 *   총량(cart-items)으로 의미가 갈려서, 읽는 순간 그 규약을 이 파일이 함께 짊어지게 된다.
 *
 * 이 파일은 장바구니만 안다. 플랫폼 분기는 app-bridge.js 가 안다.
 */
(function () {
  'use strict';

  var app = window.PiyonnaApp;

  // 일반 브라우저에서는 리스너도 달지 않고 요청도 하지 않는다
  if (!app || !app.isAvailable()) return;

  var PAGE_ID = 'cart';

  // 응답 순서 뒤집힘 방어 — 담기를 빠르게 두 번 누르면 응답이 역순으로 도착할 수 있다
  var seq = 0;

  function cartJsUrl() {
    var base = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function isCount(value) {
    return typeof value === 'number' && isFinite(value) && value >= 0;
  }

  function fetchCount() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return cart && isCount(cart.item_count) ? cart.item_count : null;
      })
      .catch(function () {
        // 조회 실패는 이번 보고만 건너뛴다. 다음 트리거에서 다시 맞춘다
        return null;
      });
  }

  /**
   * 배지 보고.
   * @param {number|null} known - 이미 확정된 총 수량. 없으면 null → 서버 조회
   */
  function report(known) {
    var mine = ++seq;
    var resolved = isCount(known) ? Promise.resolve(known) : fetchCount();

    resolved.then(function (count) {
      if (mine !== seq) return; // 더 새 보고가 이미 떠났다 → 버린다
      if (!isCount(count)) return; // 조회 실패 → 배지는 직전 값을 유지한다

      app.setTabBadge(PAGE_ID, count);
    });
  }

  // 초기 보고 — 이 페이지를 그린 서버가 이미 총량을 알고 있다.
  // 앱은 배지를 영속하지 않으므로(규약 3.1) 재실행 직후에도 맞추려면 모든 지면에서 보고해야 한다.
  report(isCount(window.PiyonnaAppCartCount) ? window.PiyonnaAppCartCount : null);

  // 담기 · 삭제 · 수량 변경. cart 전체를 실어 보내는 발신처가 있어 그때는 요청을 아낀다
  document.addEventListener('cart:update', function (event) {
    var cart = event.detail && event.detail.resource;
    report(cart && isCount(cart.item_count) ? cart.item_count : null);
  });

  // bfcache 복원 — 서버 렌더 값이 오래됐다
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) report(null);
  });

  // 웹뷰가 다시 보일 때. best-effort — iOS 웹뷰에서 발생 보장이 없고, 안 와도 배지 정확성에는
  // 영향이 없다(다음 담기 때 서버 총량으로 다시 맞춰진다)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) report(null);
  });
})();
